var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 19,
    viewBox: "0 0 98 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2497_8471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1604 17.9892C96.4604 17.9892 95.7604 17.9892 94.9904 17.9892C94.9904 17.3592 94.9904 16.7992 94.9904 16.0292C94.6404 16.3092 94.3604 16.4492 94.1504 16.5892C91.5604 18.4792 88.0604 18.4792 85.5404 16.5892C82.9504 14.6992 81.9704 11.3392 83.0204 8.32923C84.0704 5.31923 86.9404 3.35923 90.1604 3.49923C93.3804 3.63923 96.1804 5.94923 96.9504 9.09923C97.0204 9.37923 97.0904 9.58923 97.1604 9.79923C97.1604 12.5292 97.1604 15.2592 97.1604 17.9892ZM89.9504 5.94923C87.2904 5.94923 85.1204 8.11923 85.0504 10.7092C85.0504 13.2992 87.2904 15.5392 89.8804 15.5392C92.4704 15.5392 94.6404 13.3692 94.6404 10.7792C94.7104 8.11923 92.6104 6.01923 89.9504 5.94923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36016 0.140625C3.36016 3.99063 3.36016 11.8306 3.36016 11.8306L10.3602 3.85063C10.3602 3.85063 12.8102 3.85063 13.7202 3.85063C11.7602 6.09063 10.0102 8.12063 8.19016 10.2906C10.4302 12.8106 12.6702 15.3306 15.1202 18.0606C13.9302 18.0606 11.9002 18.0606 11.9002 18.0606C11.9002 18.0606 8.19016 14.0006 6.58016 12.1806C5.53016 13.3706 3.43016 15.6806 3.43016 15.6806V18.0606C3.43016 18.0606 1.75016 18.0606 0.910156 18.0606C0.910156 12.1106 0.910156 6.09063 0.910156 0.140625C1.68016 0.140625 2.52016 0.140625 3.36016 0.140625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1219 0.210938C57.1219 1.40094 57.1219 2.59094 57.1219 3.92094C58.4519 3.92094 59.7819 3.92094 61.1119 3.92094C61.1119 4.76094 61.1119 5.53094 61.1119 6.37094C59.8519 6.37094 58.5219 6.37094 57.1919 6.37094C57.1919 8.96094 57.1219 11.4109 57.1919 13.7909C57.2619 14.9109 58.2419 15.6109 59.6419 15.8209C60.1319 15.8909 60.6219 15.8909 61.1119 15.9609C61.1119 16.5909 61.1119 17.2209 61.1119 17.8509C59.5019 18.1309 57.9619 18.1309 56.5619 17.2909C55.3019 16.5909 54.6719 15.4709 54.6719 14.0009C54.6719 9.73094 54.6719 0.210938 54.6719 0.210938C54.6719 0.210938 56.2819 0.210938 57.1219 0.210938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7388 0.210938C19.7388 0.210938 19.7388 1.54094 19.7388 2.24094C18.8988 2.24094 17.2188 2.24094 17.2188 2.24094V0.210938H19.7388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7114 17.993H22.1914C22.1914 17.993 22.1214 12.463 22.4014 9.80299C22.8214 6.30299 26.0414 3.78299 29.4714 3.85299C33.0414 3.99299 36.0514 6.51299 36.3314 10.153C36.5414 12.743 36.4014 17.993 36.4014 17.993H34.0214C34.0214 17.993 34.0214 13.093 34.0214 11.133C33.9514 8.75299 32.4814 6.93299 30.3114 6.44299C28.1414 6.02299 26.0414 7.07299 25.2014 9.03299C24.9214 9.73299 24.7814 10.573 24.7814 11.343C24.6414 13.653 24.7114 17.993 24.7114 17.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4103 14.2826C80.2903 16.9426 76.7203 18.5526 73.7103 17.9226C70.2803 17.1526 67.9003 14.1426 67.9703 10.6426C68.0403 7.21262 70.5603 4.34262 74.1303 3.71262C76.8603 3.22262 80.4303 4.83262 81.4103 7.42262C80.5003 7.42262 78.4003 7.42262 78.4003 7.42262C78.4003 7.42262 77.9803 7.00262 77.5603 6.72262C75.6703 5.39262 73.0103 5.95262 71.4703 7.77262C70.0003 9.52262 69.9303 12.1126 71.4003 13.8626C72.8703 15.6826 75.3903 16.1726 77.4903 14.9826C78.1903 14.5626 78.4703 14.2826 78.4703 14.2826C78.4703 14.2826 80.2203 14.2826 81.4103 14.2826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6687 3.92188V17.9919H17.2888L17.2188 3.92188H19.6687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8716 0.210938C65.8716 0.210938 65.8716 1.54094 65.8716 2.24094C65.0316 2.24094 63.3516 2.24094 63.3516 2.24094V0.210938H65.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8016 3.92188V17.9919H63.4216L63.3516 3.92188H65.8016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4994 9.73438H38.3594V12.4644H52.4994V9.73438Z",
    fill: "url(#brand-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4994 6.86281H38.3594V4.90281C38.3594 4.90281 38.9894 4.13281 45.4294 4.13281C51.8694 4.13281 52.4994 4.90281 52.4994 4.90281V6.86281Z",
    fill: "url(#brand-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 15.2578H52.4994V17.2178C52.4994 17.2178 51.8694 17.9878 45.4294 17.9878C38.9894 17.9878 38.3594 17.2178 38.3594 17.2178V15.2578Z",
    fill: "url(#brand-gradient)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 4,
    x2: 0,
    y2: 18
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a78bfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c3aed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2497_8471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 18.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cbff56d47a244637c8738e4b73f1142a.svg";
export { ForwardRef as ReactComponent };